<template>
  <transition name="fade-transform" mode="out-in">
    <div ref="titanMainViewportMicro" class="titan-app-main-viewport">
      <!-- 子应用渲染区，用于挂载子应用节点 -->
      <template v-if="microData?.isIframe">
        <iframe
          v-if="iframeSrc"
          ref="iframe"
          name="appIframe"
          :src="iframeSrc"
          width="100%"
          height="99%"
          frameborder="no"
          border="0"
          marginwidth="0"
          marginheight="0"
          scrolling="auto"
          allowtransparency="true"
        ></iframe>
        <div v-show="!iframeSrc">应用加载失败，接入错误，请联系管理员</div>
      </template>
      <div v-else ref="containerRef" id="frame-viewport">
        <mate-empty status="loading" />
      </div>
    </div>
  </transition>
</template>
<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import useMatestoreStore from '@/store/matestoreStore';
import { onBeforeRouteUpdate, RouteLocation, useRoute } from 'vue-router';
import type { MicroData } from '@/api/model/globalModel';
import MateEmpty from '@/components/MateEmpty.vue';
import NProgress from 'nprogress';
import qs from 'qs';

const containerRef = ref(null);
const route = useRoute();
const mateStore = useMatestoreStore();
const microData = ref<MicroData>();

onMounted(() => {
  const { name } = route;
  microData.value = mateStore.findMicroApp(name as string);
  mateStore.activateMicroApp(name as string, containerRef.value);
});

const getPathWithQuery = (route: RouteLocation) => {
  return `${route.path}${
    Object.keys(route.query).length ? '?' : ''
  }${qs.stringify(route.query)}`;
};

onBeforeRouteUpdate((to, from, next) => {
  if (getPathWithQuery(to) === getPathWithQuery(from)) {
    NProgress.done();
    return;
  }
  next();
});

/**
 * 窗口类型
 */
const iframeSrc = computed(() => {
  const micro = microData.value;
  if (!micro?.entry) {
    return;
  }
  const fillUrl = route.query?.fillUrl || '';
  if (typeof fillUrl === 'string' && /^\//.test(fillUrl)) {
    const url = new URL(micro?.entry);
    return `${url.origin}${fillUrl}`;
  }
  return `${micro?.entry}${route.query?.fillUrl || ''}`;
});
</script>

<style lang="scss" scoped>
.titan-app-main-viewport {
  overflow: auto;
  height: 100%;
  & > div {
    height: inherit;
  }
}
</style>
<style lang="scss">
.titan-app-main-viewport {
  #frame-viewport {
    height: 100%;
    & > * {
      height: inherit;
    }
  }
}

/* fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* breadcrumb transition */
.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.5s;
}

.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-move {
  transition: all 0.5s;
}

.breadcrumb-leave-active {
  position: absolute;
}
</style>
